import React, { useMemo } from 'react';
import { NavGlobal } from 'components/organisms';
import { useUserContext } from 'context/UserContext';
import { useAppContext, actions } from 'context/AppContext';
import { useRouterContext } from 'hooks';
import { matchPath } from 'react-router-dom'

/**
 * Global Navigation: Change between subwebs
 */

const NavGlobalContainer = () => {
  const [{ isGlobalNavOpen }, dispatch] = useAppContext();
  const [{
    user, subwebsFavorites
  }] = useUserContext();
  const {
    location: {
      pathname
    }
  } = useRouterContext();

  const handleFocusSearch = isFocus => {
    dispatch({
      type: actions.NAV_GLOBAL_OPEN_UPDATE,
      data: isFocus,
    });
  };

  // check if user is admin
  const isAdmin = (user && user.admin)

  const subwebs = useMemo(() => {
    if (!user || !user.subwebs) return []

    if (
      subwebsFavorites && subwebsFavorites.length > 0 && user.subwebs.length > 0
    ) return user.subwebs.filter(subweb => subwebsFavorites.includes(subweb.slug))

    return user.subwebs
  }, [user, subwebsFavorites])

  const params = useMemo(() => {
    const match = matchPath(pathname, {
      path: '/:subweb',
      exact: false,
    });
    if (match && match.params) return match.params;
    return null;
  }, [pathname]);

  const bottomActions = useMemo(() => {
    // support and profile routes would be identified as a subweb, but they are routes
    const nonSubwebRoutes = ['support', 'profile']
    const isOutsideSubweb = !(params && params.subweb) || nonSubwebRoutes.includes(params.subweb)
    const list = [
      {
        to: isOutsideSubweb ? '/' : `/${params.subweb}/assets`,
        icon: 'fal fa-images',
        title: 'Galeria',
        tooltip: isOutsideSubweb ? 'Galeria de uma subweb' : 'Galeria de imagens',
        isDisabled: isOutsideSubweb
      },
      {
        to: isOutsideSubweb ? '/' : `/${params.subweb}/files/pt`,
        icon: 'fal fa-file',
        title: 'Ficheiros',
        tooltip: isOutsideSubweb ? 'Ficheiros de uma subweb' : 'Ficheiros',
        isDisabled: isOutsideSubweb
      },
      {
        to: '/support',
        icon: 'fal fa-question-circle',
        title: 'Ajuda',
      },
      isAdmin ? {
        to: '/admin',
        icon: 'fal fa-cog',
        title: 'Ferramentas de Administração',
      } : null,
    ]
    return list.filter(el => el !== null)
  }, [params])

  return (
    <NavGlobal
      shouldOpenOnHover={false}
      onFocusSearch={() => handleFocusSearch(true)}
      onBlurSearch={() => handleFocusSearch(false)}
      sites={subwebs}
      user={user}
      subweb={params && params.subweb}
      bottomActions={bottomActions}
      isOpen={isGlobalNavOpen}
    />
  );
};

NavGlobalContainer.propTypes = {};

export default NavGlobalContainer;
